import React from 'react';
import { makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import Typography from '@material-ui/core/Typography';
import { useLanguage } from '../../../../context/language/language';

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.custom.colors.red10,
    borderRadius: 12,
    padding: 14,
    paddingTop: 0,
    paddingBottom: 0,
    marginBottom: 8,
  },
  text: {
    ...theme.fonts.textS,
    fontWeight: 400,
    marginTop: 10,
    color: theme.custom.colors.red600,
    [theme.breakpoints.down('xs')]: {
      marginTop: 4,
    }
  },
  icon: {
    marginTop: 8,
    width: 20,
    color: theme.custom.colors.red600,
    [theme.breakpoints.down('xs')]: {
      marginTop: 12,
    }
  }
}));

const RoadWarning = () => {
  const classes = useStyles();
  const word = useLanguage();

  return (
    <Grid container justify="flex-start" alignContent="center" className={classes.root} spacing={1} wrap="nowrap">
      <Grid item>
        <AccessTimeIcon className={classes.icon} />
      </Grid>
      <Grid item>
        <Typography variant="body1" className={classes.text}>
          {word('DeliveryAddress.Edit.Road')}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default RoadWarning;
